<template>
    <div>
        <v-card>
            <v-card-title>Damages
                <span v-if="claim_description" class="ml-4" style="font-size: 1rem; color: #1976d2; background-color: rgba(25, 118, 210, 0.1); border: 1px solid #1976d2; border-radius: 8px; padding: 4px 10px; display: inline-flex; align-items: center;">
                    <v-icon color="#1976d2" size="24" class="mr-2">mdi-information</v-icon>{{ claim_description }}
                </span>
                <v-spacer></v-spacer>
                <div v-if="huov_hosm.length === 0"> 
                    <v-btn class="primary ma-2" x-small v-on:click="addHosm">Add new claim</v-btn>
                </div>
            </v-card-title>
            <span v-if="huov_hosm.length === 0">
                <div class="pl-4 pt-3 pb-4">                
                    <v-label><span :class="{'text-color-error': hasError}">{{ this.resulttext }}</span></v-label>
                </div>
            </span>
            <span v-else>
                <incident_table :data="huov_hosm" @executeFunction="executeFunction" itemtype="claim" class="pb-2 px-2"></incident_table>
            </span>
            <viewHsmr ref="viewHsmr" :isVisible="showDetails" :claim_description="claim_description" @updateField="updateField" @updateData="updateData" @executeFunction="executeFunction" class="pb-2"/>
        </v-card>
        <addHosm ref="addHosm" :huov_encrid="huov_encrid" :claim_description="claim_description" @updateData="updateData"/>
        <rmHosm ref="rmHosm" :huov_encrid="huov_encrid" @updateData="updateData" @updateField="updateField"/>
        <updHosm ref="updHosm" :huov_encrid="huov_encrid" :claim_description="claim_description" @updateData="updateData"/>
        <addHsmr ref="addHsmr" :claim_description="claim_description" @updateData="updateData"/>
        <m_attm ref="m_attm" @updateData="updateData"/>
    </div>
</template>

<script>

    import incident_table from '@/components/huov/ui/tables/hokl_hosm_table.vue'
    import addHosm from "@/components/huov/hosm/addHosm.vue";
    import rmHosm from "@/components/huov/hosm/rmHosm.vue";
    import updHosm from "@/components/huov/hosm/updHosm.vue";
    import viewHsmr from "@/components/huov/hosm/viewHsmr.vue";
    import addHsmr from "@/components/huov/hosm/addHsmr.vue";
    import m_attm from "@/components/m_attm.vue";
    
    export default {
        mounted(){
            this.getHosm();
            this.getClaimType();
        },
        props: {
            huov_encrid: String,
        },        
        components: {
            incident_table,
            addHosm,
            updHosm,
            rmHosm,
            viewHsmr,
            addHsmr,
            m_attm,
        },      
        data() {
            return {
                huov_hosm: [],
                resulttext: 'No complaints filed',
                hasError: false,
                showDetails: false,
                hosm_encrid: '',
                claim_description: '',
            }
        },
        methods: {         
            executeFunction(data){
                this.hosm_encrid = data[1].value;
                switch(data[0].value){
                    case 'update_claim':
                        this.$refs.updHosm.open(data[1].value, data[2].value);
                        break;
                    case 'delete_claim':
                        this.$refs.rmHosm.open(data[1].value, data[2].value);
                        break;    
                    case 'open_claim':     
                        this.$refs.viewHsmr.open(data[1].value, data[2].value);
                        break;
                    case 'add_claim_event': 
                        this.$refs.addHsmr.open(data[1].value);
                        break;
                    case 'email_claim':
                        this.sendHosm();
                        break;
                    case 'attachments_claim':
                        this.hosmAttm(data[2].value);
                        break;    
                }
            },               
            getHosm(){
                this.$axios
                    .post("ares/json/ares/huov/hosm/getHosm.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getHosm"
                        },
                        getHosm: {
                            huov_encrid: this.huov_encrid
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                            this.resulttext = res.data.error.message;
                            this.hasError = true;
                        } else {                   
                            this.huov_hosm = res.data.huov_hosm.hosm;         
                            this.hasError = false;
                        }
                    });   
                },               
            getClaimType(){
                this.$axios
                    .post("ares/json/ares/huov/hosm/getHosmClaimType.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getHosmClaimType"
                        },
                        getHosmClaimType: {
                            huov_encrid: this.huov_encrid
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.claim_description = res.data.getHosmClaimType.description;
                        }
                    });
            },
            addHosm(){
                this.$refs.addHosm.open();
            },
            updateField(data){
                this[data.field]=data.value;
            },
            updateData(){
                this.getHosm();
                if(this.showDetails){ // get details if they are visible
                    this.$refs.viewHsmr.getHsmr(this.hosm_encrid);
                }
                this.$emit('updateData', 'refresh'); // send refresh to parent
            },
            sendHosm(){
                let route = this.$router.resolve({ path: `/huov/hosm/sendHosm/${this.huov_encrid}:${this.hosm_encrid}`}); 
                window.open(route.href, '_blank');                
            },
            hosmAttm(hosm_code){
                this.$refs.m_attm.open('hosm', hosm_code, '', '', this.hosm_encrid, 0);
            }
        }
    }
</script>

<style scoped>
    .text-color-error{
        color: red;
    }
    .v-label{
        color: '';
    }
</style>